import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useMonthOptions = () => {
    const { t } = useTranslation();

    return useMemo(
        () => [
            t('common.january'),
            t('common.february'),
            t('common.march'),
            t('common.april'),
            t('common.may'),
            t('common.june'),
            t('common.july'),
            t('common.august'),
            t('common.september'),
            t('common.october'),
            t('common.november'),
            t('common.december'),
        ],
        [t],
    );
};
